import { Button, Col, Form, Input, InputNumber, Modal, notification, Popconfirm, Radio, Row, Space, Spin, Table, Tag, Typography } from 'antd'
import React, { Component } from 'react'
import moment from 'moment'
import { PricingAPI } from '../../../controller/PricingAPI';

const totalScore = (record) => ((record.score_booking / 10 * 5) * 0.3 + record.score_google * 0.3 + (record.score_agoda / 10 * 5) * 0.2 + record.score_expedia * 0.2).toFixed(2)

export class HotelPage extends Component {
    state = {
        loading: false,
        details: [],
        showAddModal: false,
        modalLoading: false,
        selectId: null,
        mode: 'store'
    };
    form = React.createRef();

    componentDidMount() {
        this.refresh();
    }
    refresh = () => {
        this.setState({ loading: true });
        PricingAPI.hotels.index({}, 1, 999).then((response) => {
            const result = response.data;
            this.setState({
                details: result.data.sort((a, b) => {
                    if (a.stars === b.stars) return totalScore(b) - totalScore(a);
                    return b.stars - a.stars;
                })
            });
        }).finally(() => {
            this.setState({ loading: false });
        });
    }
    showUpdateModal = (id) => {
        this.setState({ showAddModal: true, mode: 'update', modalLoading: true, selectId: id });
        PricingAPI.hotels.show(id).then((response) => {
            console.log(response);
            this.form.current.setFieldsValue(response.data);
        }).finally(() => {
            this.setState({ modalLoading: false });
        });
    }
    showAddModal = () => {
        this.setState({ showAddModal: true, mode: 'store' });
    }
    closeAddModel = () => {
        this.form.current.submit();
        this.setState({ showAddModal: false });
    }
    cancelAddModel = () => {
        this.setState({ showAddModal: false, selectId: null, mode: 'store' });
        this.form.current.resetFields();
    }
    // 後端 422 是特地寫給使用者看的錯誤訊息 (例如本館不可停用)，
    // 沒有 .catch() 的話視窗已經關閉，使用者完全看不到、表格也毫無變化。
    handleRequestError = (error) => {
        const message = error?.response?.data?.message || '儲存失敗，請稍後再試';
        notification.error({ message });
    }
    handleAdd = (values) => {
        this.setState({ modalLoading: true });
        if (this.state.mode === 'store') {
            PricingAPI.hotels.store(values).then((response) => {
                console.log(response);
                notification.info({ message: '新增成功' });
            }).catch(this.handleRequestError).finally(() => {
                this.setState({ modalLoading: false });
                this.refresh();

            })
        } else {
            PricingAPI.hotels.update(this.state.selectId, values).then((response) => {
                console.log(response);
                notification.info({ message: '修改成功' });
            }).catch(this.handleRequestError).finally(() => {
                this.setState({ modalLoading: false });
                this.refresh();
            })
        }
    }
    // Radio 用 disabled 反灰「停用」選項，但既有選中值不會因此被清掉——
    // 若在停用狀態下把「本飯店」改成「是」，會送出 self=1 又 disabled=1 給後端，
    // 落地 422。本飯店切成「是」時一併把狀態撥回啟用，從源頭避免這個組合。
    handleValuesChange = (changedValues) => {
        if (Number(changedValues.self) === 1) {
            this.form.current.setFieldsValue({ disabled: 0 });
        }
    }
    handleDelete = (id) => {
        this.setState({ loading: true });
        PricingAPI.hotels.destroy(id).then((response) => {
            notification.info({ message: '刪除成功' });
            this.refresh();
        }).finally(() => {
            this.setState({ loading: false });
        })
    }
    render() {
        const columns = [
            {
                title: '本飯店',
                dataIndex: 'self',
                key: 'self',
                // 原本直接輸出 0 / 1，與右側的狀態 Tag 並排時很突兀
                render: (value) => (Number(value) === 1 ? <Tag color="blue">本館</Tag> : null)
            },
            {
                title: '狀態',
                dataIndex: 'disabled',
                key: 'disabled',
                render: (value) => (Number(value) === 1
                    ? <Tag>已停用</Tag>
                    : <Tag color="green">啟用中</Tag>)
            },
            {
                title: '名稱',
                dataIndex: 'name',
                key: 'name',
                render: (value, record) => <Typography.Link onClick={this.showUpdateModal.bind(this, record.id)}>{value}</Typography.Link>
            },
            {
                title: '排名',
                dataIndex: 'rank',
                key: 'rank',
                sorter: (a, b) => a.rank - b.rank
            },
            {
                title: '星級',
                dataIndex: 'stars',
                key: 'stars',
                sorter: (a, b) => a.stars - b.stars
            },
            {
                title: '綜合分數',
                render: (value, record) => totalScore(record),
                sorter: (a, b) => totalScore(a) - totalScore(b)
            },
            {
                title: 'Booking 分數',
                dataIndex: 'score_booking',
                key: 'score_booking',
                sorter: (a, b) => a.score_booking - b.score_booking
            },
            {
                title: 'Google 分數',
                dataIndex: 'score_google',
                key: 'score_google',
                sorter: (a, b) => a.score_google - b.score_google
            },
            {
                title: 'Agoda 分數',
                dataIndex: 'score_agoda',
                key: 'score_agoda',
                sorter: (a, b) => a.score_agoda - b.score_agoda
            },
            {
                title: 'Expedia 分數',
                dataIndex: 'score_expedia',
                key: 'score_expedia',
                sorter: (a, b) => a.score_expedia - b.score_expedia
            },
            {
                title: '代號',
                dataIndex: 'id',
                key: 'id',
                render: (value) => <a target="_blank" rel="noreferrer" href={`https://www.booking.com/hotel/tw/${value}.zh-tw.html`}>{value}</a>
            },
            {
                title: '價格總筆數',
                dataIndex: 'price_count',
                key: 'price_count',
                align: 'right',
            },
            {
                title: '價格最後更新',
                dataIndex: 'last_update',
                key: 'last_update',
                render: (value) => moment(value).format('llll')
            },
            {
                title: '修改日期',
                dataIndex: 'updated_at',
                key: 'updated_at',
                render: (value) => moment(value).format('llll')
            },
            {
                title: '動作',
                key: 'action',
                fixed: 'right',
                render: (value, record) => <Space size="middle">
                    <Typography.Link onClick={this.showUpdateModal.bind(this, record.id)}>修改</Typography.Link>
                    <Popconfirm title={`你是否確定要刪除${record.name}?`} onConfirm={this.handleDelete.bind(this, record.id)} okText="是" cancelText="否">
                        <Typography.Link>刪除</Typography.Link>
                    </Popconfirm>
                </Space>
            }
        ];
        return (
            <div>
                <h1>飯店管理</h1>
                <Row justify="end" style={{ marginBottom: 10 }}>
                    <Col>
                        <Space>
                            <Button type="primary" onClick={this.showAddModal}>新增</Button>
                        </Space>
                    </Col>
                </Row>
                <Table columns={columns} dataSource={this.state.details} rowKey="id" loading={this.state.loading} scroll={{ x: 'max-content' }} pagination={{ pageSize: 30 }} size="small"
                    onRow={(record) => ({
                        style: Number(record.disabled) === 1 ? { color: '#BFBFBF' } : undefined
                    })}
                />
                <Modal title={`${this.state.mode === 'store' ? '新增' : '修改'}飯店`} visible={this.state.showAddModal} onOk={this.closeAddModel} onCancel={this.cancelAddModel} confirmLoading={this.state.modalLoading}>
                    <Spin spinning={this.state.modalLoading}>
                        <Form ref={this.form} onFinish={this.handleAdd} onValuesChange={this.handleValuesChange} initialValues={{ self: 0, disabled: 0, rank: 99 }} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                            <Form.Item
                                label="代號"
                                name="id"
                                rules={[
                                    { required: true, message: '請輸入飯店代號' },
                                    { pattern: /^[a-z0-9-]+$/, message: '代號只能包含小寫字母、數字和連字符' }
                                ]}
                            >
                                <Input placeholder="例如：li-li-da-jiu-dian" />
                            </Form.Item>
                            <Form.Item
                                label="名稱"
                                name="name"
                                rules={[
                                    { required: true, message: '請輸入飯店名稱' },
                                    { min: 2, message: '飯店名稱至少需要2個字符' }
                                ]}
                            >
                                <Input placeholder="例如：立麗大酒店" />
                            </Form.Item>
                            <Form.Item
                                label="本飯店"
                                name="self"
                                valuePropName="value"
                                // Radio 用嚴格相等判斷選中；setFieldsValue(response.data) 直接寫入 API
                                // 回傳的原始值，一旦 Hotel model 日後幫這個欄位加上布林 cast，
                                // 數字 Radio 就會比對不到而靜靜變成未選中。統一轉成 Number 防呆。
                                normalize={(value) => Number(value)}
                                rules={[{ required: true, message: '請選擇是否為本飯店' }]}
                            >
                                <Radio.Group>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item
                                noStyle
                                shouldUpdate={(prev, next) => prev.self !== next.self}
                            >
                                {({ getFieldValue }) => (
                                    <Form.Item
                                        label="狀態"
                                        name="disabled"
                                        valuePropName="value"
                                        // 同上一個 Form.Item 的理由：防未來 model 加上布林 cast 後 Radio 選不中。
                                        normalize={(value) => Number(value)}
                                        rules={[{ required: true, message: '請選擇狀態' }]}
                                        extra={Number(getFieldValue('self')) === 1
                                            ? '本飯店是走勢圖與競品排名的基準，不可停用。'
                                            : '停用後該飯店的價格不列入建議價格與走勢圖的計算。'}
                                    >
                                        <Radio.Group>
                                            <Radio value={0}>啟用</Radio>
                                            <Radio value={1} disabled={Number(getFieldValue('self')) === 1}>停用</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                )}
                            </Form.Item>
                            <Form.Item
                                label="排名"
                                name="rank"
                                rules={[
                                    { required: true, message: '請輸入排名' },
                                    { type: 'number', min: 1, max: 999, message: '排名必須在1-999之間' }
                                ]}
                            >
                                <InputNumber placeholder="99" min={1} max={999} style={{ width: '100%' }} />
                            </Form.Item>
                            <Form.Item
                                label="星級"
                                name="stars"
                                rules={[
                                    { required: true, message: '請輸入星級' },
                                    { type: 'number', min: 1, max: 5, message: '星級必須在1-5之間' }
                                ]}
                            >
                                <InputNumber placeholder="4" min={1} max={5} style={{ width: '100%' }} />
                            </Form.Item>
                            <Form.Item
                                label="Booking 分數"
                                name="score_booking"
                                rules={[
                                    { required: true, message: '請輸入Booking分數' },
                                    {
                                        validator: (_, value) => {
                                            if (value === null || value === undefined) return Promise.resolve();
                                            const num = parseFloat(value);
                                            if (isNaN(num) || num < 0 || num > 10) {
                                                return Promise.reject(new Error('Booking分數必須在0-10之間的數字'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <InputNumber placeholder="8.5" stringMode={true} step="0.1" min={0} max={10} style={{ width: '100%' }} />
                            </Form.Item>
                            <Form.Item
                                label="Google 分數"
                                name="score_google"
                                rules={[
                                    { required: true, message: '請輸入Google分數' },
                                    {
                                        validator: (_, value) => {
                                            if (value === null || value === undefined) return Promise.resolve();
                                            const num = parseFloat(value);
                                            if (isNaN(num) || num < 0 || num > 5) {
                                                return Promise.reject(new Error('Google分數必須在0-5之間的數字'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <InputNumber placeholder="4.2" stringMode={true} step="0.1" min={0} max={5} style={{ width: '100%' }} />
                            </Form.Item>
                            <Form.Item
                                label="Agoda 分數"
                                name="score_agoda"
                                rules={[
                                    { required: true, message: '請輸入Agoda分數' },
                                    {
                                        validator: (_, value) => {
                                            if (value === null || value === undefined) return Promise.resolve();
                                            const num = parseFloat(value);
                                            if (isNaN(num) || num < 0 || num > 10) {
                                                return Promise.reject(new Error('Agoda分數必須在0-10之間的數字'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <InputNumber placeholder="8.0" stringMode={true} step="0.1" min={0} max={10} style={{ width: '100%' }} />
                            </Form.Item>
                            <Form.Item
                                label="Expedia 分數"
                                name="score_expedia"
                                rules={[
                                    { required: true, message: '請輸入Expedia分數' },
                                    {
                                        validator: (_, value) => {
                                            if (value === null || value === undefined) return Promise.resolve();
                                            const num = parseFloat(value);
                                            if (isNaN(num) || num < 0 || num > 5) {
                                                return Promise.reject(new Error('Expedia分數必須在0-5之間的數字'));
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <InputNumber placeholder="4.0" stringMode={true} step="0.1" min={0} max={5} style={{ width: '100%' }} />
                            </Form.Item>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        )
    }
}

export default HotelPage